import { render, staticRenderFns } from "./VentanasEnturnamientoForm.vue?vue&type=template&id=32298e82"
import script from "./VentanasEnturnamientoForm.vue?vue&type=script&lang=js"
export * from "./VentanasEnturnamientoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports